module.exports = __webpack_public_path__ + "static/media/Product_Heart_shadow.1e4e0019.svg";